/**
 * Dynamic delivery information.
 * Calculates delivery messaging and keeps countdown text current.
 */

(function() {
  'use strict';

  var BLOCK_SELECTOR = '[data-delivery-block-id]';
  var intervalId = null;
  var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function getMinutesFromMidnight(date) {
    return (date.getHours() * 60) + date.getMinutes();
  }

  function getNextDayName(currentDate, daysToAdd) {
    var futureDate = new Date(currentDate);
    futureDate.setDate(futureDate.getDate() + daysToAdd);
    return dayNames[futureDate.getDay()];
  }

  function formatTimeRemaining(minutes) {
    var safeMinutes = Math.max(0, minutes);

    if (safeMinutes < 60) {
      return safeMinutes + ' minutes';
    }

    var hours = Math.floor(safeMinutes / 60);
    var remainingMinutes = safeMinutes % 60;

    if (remainingMinutes === 0) {
      return hours + ' hour' + (hours > 1 ? 's' : '');
    }

    return hours + ' hour' + (hours > 1 ? 's' : '') + ' ' + remainingMinutes + ' minutes';
  }

  function getDeliveryText(now) {
    var currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    var currentTime = getMinutesFromMidnight(now);

    // Monday to Wednesday
    if (currentDay >= 1 && currentDay <= 3) {
      if (currentTime < 15 * 60) {
        var nextDay = getNextDayName(now, 1);
        var minutesToCutoff = (15 * 60) - currentTime;
        return 'Get it ' + nextDay + ' - Order in ' + formatTimeRemaining(minutesToCutoff);
      }

      var dayAfterTomorrow = getNextDayName(now, 2);
      return 'Get it ' + dayAfterTomorrow + ' - Order before 3pm tomorrow';
    }

    // Thursday
    if (currentDay === 4) {
      if (currentTime < 15 * 60) {
        return 'Get it Friday - Order in ' + formatTimeRemaining((15 * 60) - currentTime);
      }

      return 'Get it Saturday - Order before 3pm tomorrow';
    }

    // Friday
    if (currentDay === 5) {
      if (currentTime < 15 * 60) {
        return 'Get it Saturday - Order in ' + formatTimeRemaining((15 * 60) - currentTime);
      }

      // After 3pm Friday, countdown to Saturday 12pm cutoff for Sunday delivery.
      var minutesToSaturdayNoon = ((24 * 60) - currentTime) + (12 * 60);
      return 'Get it Sunday - Order in ' + formatTimeRemaining(minutesToSaturdayNoon);
    }

    // Saturday
    if (currentDay === 6) {
      if (currentTime < 12 * 60) {
        return 'Get it Sunday - Order in ' + formatTimeRemaining((12 * 60) - currentTime);
      }

      return 'Get it Tuesday - Order before Monday at 3pm';
    }

    // Sunday
    return 'Get it Tuesday - Order before Monday at 3pm';
  }

  function parseDeliveryText(deliveryText) {
    var parts = deliveryText.split(' - ');

    if (parts.length === 2) {
      return {
        deliveryDate: parts[0],
        orderDeadline: parts[1]
      };
    }

    return {
      deliveryDate: deliveryText,
      orderDeadline: ''
    };
  }

  function renderDeliveryElement(deliveryElement, deliveryText) {
    if (!deliveryElement) return;

    var deliveryParts = parseDeliveryText(deliveryText);
    var html = '<span class="delivery-information__delivery-date">' + deliveryParts.deliveryDate + '</span>';

    if (deliveryParts.orderDeadline) {
      html += '<span class="delivery-information__separator"> - </span><span class="delivery-information__order-deadline">' + deliveryParts.orderDeadline + '<sup>*</sup></span>';
    }

    deliveryElement.innerHTML = html;
  }

  function updateAllDeliveryBlocks() {
    var now = new Date();
    var deliveryText = getDeliveryText(now);
    var deliveryBlocks = document.querySelectorAll(BLOCK_SELECTOR);

    if (!deliveryBlocks.length) {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      return;
    }

    deliveryBlocks.forEach(function(block) {
      var blockId = block.getAttribute('data-delivery-block-id');
      if (!blockId) return;
      renderDeliveryElement(document.getElementById('delivery-day-' + blockId), deliveryText);
    });
  }

  function startUpdates() {
    updateAllDeliveryBlocks();

    if (!intervalId) {
      intervalId = setInterval(updateAllDeliveryBlocks, 60000);
    }
  }

  function init() {
    if (!document.querySelector(BLOCK_SELECTOR)) return;
    startUpdates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Theme editor section re-render support.
  document.addEventListener('shopify:section:load', function() {
    init();
    updateAllDeliveryBlocks();
  });
})();
